// @ts-nocheck
import { useEffect, useMemo, useState } from 'react'

import api from './api/api'
import CreateRequestModal from './components/CreateRequestModal'
import RequestWorkPanel from './components/RequestWorkPanel'
import RequestsAgGrid from './components/RequestsAgGrid'


function PageControlRequests() {
  const [requests, setRequests] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState(null)
  const [showClosed, setShowClosed] = useState(false)
  const [isRefreshing, setIsRefreshing] = useState(false)
  const [lastUpdatedAt, setLastUpdatedAt] = useState(null)
  const [graphRefreshKey, setGraphRefreshKey] = useState(0)

  const user = useMemo(() => {
    const username = localStorage.getItem('username') || ''

    return {
      username,
      is_admin: username === 'admin',
      org: '',
      org_name: '',
    }
  }, [])

  useEffect(() => {
    document.title = 'АСПО.Контроль | Заявки КС'
    loadRequests()
    const timer = window.setInterval(loadRequests, 600000)

    return () => window.clearInterval(timer)
  }, [])

  async function loadRequests() {
    try {
      setIsRefreshing(true)

      const response = await api.get('requests/')
      const data = response.data.results || response.data

      const sorted = [...data].sort((a, b) => (
        (a.org_name || '').localeCompare(b.org_name || '', 'ru')
      ))

      setRequests(sorted)
      setSelectedRequest((current) => {
        if (!current) return null
        const listItem = sorted.find((item) => item.id === current.id)
        if (!listItem) return null

        return {
          ...current,
          ...listItem,
          comments: current.comments,
          email_notifications: current.email_notifications,
        }
      })
      setLastUpdatedAt(new Date())
      setGraphRefreshKey((value) => value + 1)

      return sorted
    } catch (error) {
      console.error(error)
      return []
    } finally {
      setIsRefreshing(false)
    }
  }

  async function loadRequestDetail(requestId, fallbackRequest = null) {
    if (fallbackRequest) {
      setSelectedRequest(fallbackRequest)
    }

    try {
      const response = await api.get(`requests/${requestId}/`)
      setSelectedRequest(response.data)
      return response.data
    } catch (error) {
      console.error(error)
      return fallbackRequest
    }
  }

  function selectRequest(request) {
    if (!request?.id) {
      setSelectedRequest(null)
      return
    }

    if (selectedRequest?.id === request.id && selectedRequest?.comments) {
      return
    }

    loadRequestDetail(request.id, request)
  }

  async function refreshRequestsAndSelected() {
    const currentId = selectedRequest?.id
    await loadRequests()

    if (currentId) {
      await loadRequestDetail(currentId)
    }
  }

  const visibleRequests = showClosed
    ? requests
    : requests.filter((request) => !['DONE', 'REJECTED', 'CANCELED'].includes(request.status))

  return (
    <div style={pageStyle}>
      <div style={topBarStyle}>
        <h2 style={titleStyle}>Заявки на контрольный спуск</h2>

        {user.is_admin && (
          <button
            type="button"
            style={primaryButtonStyle}
            onClick={() => setIsModalOpen(true)}
          >
            Создать заявку
          </button>
        )}
      </div>

      <div style={toolbarStyle}>
        <label style={checkboxLabelStyle}>
          <input
            type="checkbox"
            checked={showClosed}
            onChange={(event) => setShowClosed(event.target.checked)}
          />
          Показывать выполненные и отклоненные
        </label>
        <div style={refreshGroupStyle}>
          <span style={refreshTextStyle}>
            {lastUpdatedAt ? `Обновлено: ${formatTime(lastUpdatedAt)}` : ''}
          </span>
          <button type="button" style={refreshButtonStyle} onClick={loadRequests} disabled={isRefreshing}>
            {isRefreshing ? 'Обновляем...' : 'Обновить'}
          </button>
        </div>
      </div>

      <RequestsAgGrid
        requests={visibleRequests}
        onSelectRequest={selectRequest}
      />

      <RequestWorkPanel
        key={selectedRequest?.id || 'empty'}
        user={user}
        requests={requests}
        selectedRequest={selectedRequest}
        onSelectRequest={selectRequest}
        onUpdated={refreshRequestsAndSelected}
        refreshKey={graphRefreshKey}
      />

      {isModalOpen && (
        <CreateRequestModal
          user={user}
          onClose={() => setIsModalOpen(false)}
          onCreated={loadRequests}
        />
      )}
    </div>
  )
}

function formatTime(value) {
  return new Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(value)
}

const pageStyle = {
  padding: '14px',
  height: 'calc(100vh - 70px)',
  overflow: 'auto',
  boxSizing: 'border-box',
  background: '#f5f7fa',
}

const topBarStyle = {
  background: '#ffffff',
  border: '1px solid #cfcfcf',
  padding: '10px',
  marginBottom: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
}

const titleStyle = {
  margin: 0,
  fontSize: '18px',
}

const primaryButtonStyle = {
  height: '32px',
  padding: '0 14px',
  background: '#1976d2',
  color: '#fff',
  border: '1px solid #0d47a1',
  borderRadius: '3px',
  cursor: 'pointer',
}

const toolbarStyle = {
  background: '#ffffff',
  border: '1px solid #cfcfcf',
  padding: '8px 10px',
  marginBottom: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
}

const checkboxLabelStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '13px',
}

const refreshGroupStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}

const refreshTextStyle = {
  color: '#667085',
  fontSize: '12px',
}

const refreshButtonStyle = {
  height: '28px',
  padding: '0 10px',
  background: '#ffffff',
  border: '1px solid #b8c0cc',
  borderRadius: '3px',
  cursor: 'pointer',
}

export default PageControlRequests
